<template>
  <b-card>
    <create-contact
      class="mt-2 pt-75"
    />
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import CreateContact from './CreateContact.vue'

export default {
  components: {
    BCard,
    CreateContact,
  },
}
</script>
